import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { EVENT } from 'src/app/shared/constants/dali.constants';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { TagEvent } from 'src/app/shared/models/dali-tags.model';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { CaptureService } from 'src/app/shared/services/capture/capture.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';
import * as uuid from 'uuid';
var AttachDocumentsComponent = /** @class */ (function () {
    function AttachDocumentsComponent(copyService, headerService, navigationService, parameterService, abreCuentasService, bitacoraService, taggingService, captureService) {
        this.copyService = copyService;
        this.headerService = headerService;
        this.navigationService = navigationService;
        this.parameterService = parameterService;
        this.abreCuentasService = abreCuentasService;
        this.bitacoraService = bitacoraService;
        this.taggingService = taggingService;
        this.captureService = captureService;
        this.disableButton = true;
        this.headerService.show(false, true, true);
    }
    AttachDocumentsComponent.prototype.ngOnInit = function () {
        // TODO: this.documentList se debe reemplazar por suficiencia documental
        this.documentList = this.abreCuentasService.getDocumentarySufficiencyList();
        this.fileMaxSize = this.parameterService.getSetting(OpEnum.ATTACH_DOCUMENTS).file_max_size_MB;
        this.filesTypes = this.parameterService.getSetting(OpEnum.ATTACH_DOCUMENTS).files_types;
        this.solicitationInfo = this.abreCuentasService.getRequestModel();
        this.setDocumentInput();
    };
    AttachDocumentsComponent.prototype.next = function (code) {
        this.tagg('1', this.copyService.copies.attach_documents.back_button, '');
        this.navigationService.nextStep(code.toString());
    };
    AttachDocumentsComponent.prototype.setDocumentInput = function () {
        //// Por alguna razón ahora comienza en 2
        var counter = 2;
        this.documentList.forEach(function (element) {
            if (element.alreadyUploaded) {
                element.index = 0;
            }
            else {
                element.index = counter;
                counter++;
            }
        });
    };
    AttachDocumentsComponent.prototype.selectUploadDocument = function (element) {
        this.actualElement = element;
        var input = document.getElementsByName("input-file-" + element)[0];
        /* istanbul ignore next */
        if (input) {
            input.click();
        }
    };
    AttachDocumentsComponent.prototype.onDocumentChange = function (event) {
        this.documentList[+this.actualElement].isFileSizeCorrect = true;
        this.documentList[+this.actualElement].isFileTypeCorrect = true;
        var target = event.target;
        var file = target.files[0];
        this.documentList[+this.actualElement].file = file;
        this.documentList[+this.actualElement].fileExists = true;
        /* istanbul ignore next */
        if (file.size > (this.fileMaxSize * 1000000)) {
            this.documentList[+this.actualElement].isFileSizeCorrect = false;
            this.tagg('2', '', this.copyService.copies.attach_documents.exceeds_file_size
                + '' + this.fileMaxSize
                + '' + this.copyService.copies.attach_documents.exceeds_file_size_MB);
        }
        /* istanbul ignore next */
        console.log(file.type);
        console.log(this.filesTypes);
        if (!this.filesTypes.some(function (element) { return element === file.type; })) {
            this.documentList[+this.actualElement].isFileTypeCorrect = false;
            this.tagg('2', '', 'El documento no es tipo PDF, JPG o PNG.');
        }
        this.setBase64(this.documentList[+this.actualElement].file);
        this.changeButton();
    };
    AttachDocumentsComponent.prototype.removeDocument = function (element) {
        var input = document.getElementsByName("input-file-" + element)[0];
        /* istanbul ignore next */
        if (input) {
            input.value = '';
        }
        this.documentList[+element].fileExists = false;
        this.documentList[+element].isFileSizeCorrect = true;
        this.documentList[+element].isFileTypeCorrect = true;
        delete this.documentList[+element].file;
        this.changeButton();
    };
    AttachDocumentsComponent.prototype.areFilesSizeIncorrect = function () {
        return this.documentList.some(function (element) { return !element.isFileSizeCorrect; });
    };
    AttachDocumentsComponent.prototype.areFilesTypeIncorrect = function () {
        return this.documentList.some(function (element) { return !element.isFileTypeCorrect; });
    };
    AttachDocumentsComponent.prototype.changeButton = function () {
        var fileSize = this.documentList.some(function (element) { return element.isFileSizeCorrect === false; });
        var fileType = this.documentList.some(function (element) { return element.isFileTypeCorrect === false; });
        var fileRequiredExisR = this.documentList.some(function (element) { return element.priority === 'R'; });
        var fileRequiredExist = this.documentList.some(function (element) { return !element.fileExists && element.priority === 'R'; });
        var fileRequiredExisOpc = this.documentList.some(function (element) { return !element.fileExists && element.priority !== 'R'; });
        if (fileRequiredExisR) {
            if (!fileSize && !fileType && !fileRequiredExist) {
                this.disableButton = false;
            }
            else {
                this.disableButton = true;
            }
        }
        else {
            if (!fileSize && !fileType && !fileRequiredExisOpc) {
                this.disableButton = false;
            }
            else {
                this.disableButton = true;
            }
        }
    };
    AttachDocumentsComponent.prototype.areAllFilesUploaded = function () {
        var e_1, _a;
        var uploaded = true;
        try {
            for (var _b = tslib_1.__values(this.documentList), _c = _b.next(); !_c.done; _c = _b.next()) {
                var docum = _c.value;
                if ((docum.priority === 'R') && docum.required_ind) {
                    uploaded = false;
                }
                /* istanbul ignore next */
                // if (!docum.file) {
                //   uploaded = false;
                // }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return uploaded;
    };
    AttachDocumentsComponent.prototype.sendDocuments = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var documentsSelected, responseOkList, idFiles, i, creationDate, fielParameter, data, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        documentsSelected = this.documentList.filter(function (document) { return document.file; });
                        responseOkList = [];
                        idFiles = uuid.v4();
                        i = 0;
                        _a.label = 1;
                    case 1:
                        if (!(i < documentsSelected.length)) return [3 /*break*/, 4];
                        creationDate = this.solicitationInfo.solicitation_date_history ?
                            this.solicitationInfo.solicitation_date_history.split(',')[0] : new Date().toISOString();
                        fielParameter = {
                            document: {
                                type: this.abreCuentasService.getDocumentInfo().document_type,
                                number: this.solicitationInfo.prospects[0].document.number,
                            },
                            solicitation: {
                                solicitation_id: this.solicitationInfo.solicitation_id,
                                client_name: this.solicitationInfo.prospects[0].full_name,
                                id_files: idFiles,
                                total_files: documentsSelected.length,
                                solicitation_id_pqr: '',
                            },
                            client: {
                                person_type: 'PN',
                            },
                            additional_information: {
                                name: '',
                                key: this.formatDate(creationDate),
                            },
                        };
                        data = new FormData();
                        data.append('dependence_id', this.solicitationInfo.solicitation_id);
                        data.append('document_type', documentsSelected[i].archive_type);
                        data.append('process_name', 'pnOnboarding');
                        data.append('file_id', uuid.v4());
                        data.append('file', documentsSelected[i].file);
                        data.append('field_parameter', new Blob([JSON.stringify(fielParameter)], { type: 'application/json' }));
                        return [4 /*yield*/, this.captureService.loadDocument(data)];
                    case 2:
                        response = _a.sent();
                        if (response.code === '200') {
                            responseOkList.push(response);
                        }
                        _a.label = 3;
                    case 3:
                        i++;
                        return [3 /*break*/, 1];
                    case 4:
                        if (responseOkList.length == documentsSelected.length) {
                            this.abreCuentasService.setDocumentsUploaded(true);
                            this.setOnBaseIndexation();
                            this.tagg('1', this.copyService.copies.attach_documents.next_button, '');
                            this.sendBitacora();
                            this.next(200);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AttachDocumentsComponent.prototype.sendBitacora = function () {
        var bitacoraEvent = "document_upload";
        this.bitacoraService.saveDataInBitacora(bitacoraEvent);
    };
    AttachDocumentsComponent.prototype.setOnBaseIndexation = function () {
        var type = this.solicitationInfo.prospects[0].document.type;
        this.onBaseInfo = {
            identification: this.solicitationInfo.prospects[0].document.number,
            identificationType: type === '1' ? 'CC' : type === '2' ? 'CE' : type === '3' ? 'NIT' : 'TI',
            solicitationDate: this.formatDate(this.solicitationInfo.solicitation_date_history.split(',')[0]),
            documentDate: this.formatDate(new Date().toISOString()),
        };
    };
    AttachDocumentsComponent.prototype.formatDate = function (date) {
        var mydate = new Date(date);
        var day = mydate.getDate().toString();
        var month = (mydate.getMonth() + 1).toString();
        var year = mydate.getFullYear();
        /* istanbul ignore else */
        if (+day < 10) {
            day = "0" + day;
        }
        /* istanbul ignore else */
        if (+month < 10) {
            month = "0" + month;
        }
        return day + "/" + month + "/" + year;
    };
    AttachDocumentsComponent.prototype.setBase64 = function (file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            // console.log(reader.result);
        };
        reader.onerror = function (error) {
            console.log('error: ', error);
        };
    };
    AttachDocumentsComponent.prototype.tagg = function (tag_number, label, errorName) {
        var tagPageName = this.navigationService.getCurrentStep().tag_name;
        try {
            var changes = this.taggingService.createTagChanges(tagPageName, tag_number);
            var event_1 = {
                category: {
                    module: EVENT.customCategory.module.body,
                    type: EVENT.customCategory.type.link,
                    position: EVENT.customCategory.position.center,
                },
                action: EVENT.customAction.click,
                label: this.navigationService.camelize(label),
            };
            switch (tag_number) {
                case '2':
                    event_1.category = {
                        module: EVENT.customCategory.module.body,
                        type: EVENT.customCategory.type.warning,
                        position: EVENT.customCategory.position.top,
                    };
                    event_1.action = EVENT.customAction.show;
                    event_1.errorName = this.navigationService.camelize(errorName);
                    event_1.label = EVENT[tagPageName + "E" + tag_number + "customLabel"];
                    break;
            }
            this.taggingService.pageTagEvent(event_1, changes);
        }
        catch (error) {
            console.log("Error en " + error);
        }
    };
    return AttachDocumentsComponent;
}());
export { AttachDocumentsComponent };
